import React from 'react'
import root from '../shared/utils'
import { getTaskTypeIconParser } from '../shared/enums/task-type-icon-parser'
import { Modal } from 'react-bootstrap'
import CustomButton from './components/custom-task-button'
import ServicePlan from '../modals/components/service-plan'
import { updateServicePlan } from '../api'

let costBasic, costPremium
export default React.createClass({

  getInitialState: function () {
    return {
      packageType: 'basic',
      taskDescription: '',
      task: '',
      taskType: '',
      taskTitle: '',
      taskIcon: '',
      cost: '',
      selected: ''
    }
  },
  toggleButton: function (index) {
    this.refs.btn0.setState({selected: index === 0})
    this.refs.btn1.setState({selected: index === 1})
    if (index === 0) {
      this.setState({packageType: 'basic', cost: costBasic})
    }
    else {
      this.setState({packageType: 'premium', cost: costPremium})
    }
  },
  componentWillReceiveProps: function (nextProps) {
    let task = nextProps.task
    if (task === undefined || task === '' || task === null) {
      return
    }

    let iconTypeInfo = getTaskTypeIconParser(task.taskType)

    let costOfService
    if (nextProps.actualCost) {
      costOfService = nextProps.actualCost
    }
    else {
      costOfService = task.cost
    }

    if (!task.taskDescription) {
      this.setState({
        packageType: (task.packageDisplay.taskDisplayOption).toLowerCase(),
        taskDescription: task.intervalDisplay.title + ' / ' + task.packageDisplay.title + ' / ' + task.scheduleDisplay.title,
        taskTitle: iconTypeInfo.prettify,
        taskIcon: iconTypeInfo.iconsrc,
        cost: costOfService
      })
      let info
      for (let i = 0; i < this.props.pricingArray.length; i++) {
        info = this.props.pricingArray[i]
        info.schedule = info.schedule.replace('_', ' ')
        info.interval = info.interval.replace('BIWEEKLY', 'BI-WEEKLY')
        if (info.interval === task.intervalDisplay.title.toUpperCase()) {
          if (info.schedule === task.scheduleDisplay.title.toUpperCase()) {
            if (info.packageType === 'BASIC') {
              costBasic = info.price
            }
            else if (info.packageType === 'BUDGET') {
              costBasic = info.price
            }
            else if (info.packageType === 'PREMIUM') {
              costPremium = info.price
            }
          }
        }
      }
    }
    else {
      this.setState({
        packageType: (task.packageType).toLowerCase(),
        taskDescription: task.taskDescription,
        taskTitle: iconTypeInfo.prettify,
        taskIcon: iconTypeInfo.iconsrc,
        cost: costOfService
      })
      let info
      for (let i = 0; i < this.props.pricingArray.length; i++) {
        info = this.props.pricingArray[i]
        info.schedule = info.schedule.replace('_', ' ')
        if (info.interval === task.interval) {
          if (info.schedule === task.schedule.toUpperCase()) {
            if (info.packageType === 'BASIC') {
              costBasic = info.price
            }
            else if (info.packageType === 'PREMIUM') {
              costPremium = info.price
            }
          }
        }
      }
    }
  },
  sendUpdateToServer: function () {
    updateServicePlan(this.props.task.taskId, this.state.packageType.toUpperCase()).then((data) => {
      if (data === 'okay') {
        this.props.openNotificationModal('upgrade-service-modal', 'Your service has been updated!', 'We\'ve updated your service to the ' + this.state.packageType.toLowerCase() + ' plan')
        this.props.hide()
      }
      else {
        this.props.openNotificationModal('upgrade-service-modal', 'Processing Error', 'There was an error processing your changes. Please try again later.')
        console.log('error')
      }
    })
  },
  render: function () {
    let greenCheckFlat = root + '/common/latest/images/consumer/order-process-icons/green-check.png'

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='upgrade-modal'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6, fontSize: 20}}>
            <div className={'task-type center no-text'}>
              <div className={`${this.state.taskIcon}-icon`}/>
            </div>
            <h2 className='text-center'>{this.state.taskTitle}</h2>
            <h5 className='text-center brand-primary-color'><b>Service Plan</b></h5>
            <div style={{width: '80%', margin: 'auto'}} className="pull-down-xs-3 row">
              <p><b>Full Service</b> Lawn Mowing adds the following services to your regular lawn mowing service:</p>
            </div>
            <div style={{width: '80%', margin: 'auto'}} className="pull-down-xs-3 row">
              <div className='row pull-down-xs-2'>
                <div className='col-xs-12'>
                  <img alt='' style={{float: 'left', marginRight: 5}} src={greenCheckFlat}/>
                  <div style={{float: 'left', width: '90%'}}>
                    <p style={{float: 'left', fontSize: 18}}><b>Edging along sidewalks, pathways, and driveway</b></p>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <img alt='' style={{float: 'left', marginRight: 5}} src={greenCheckFlat}/>
                  <div style={{float: 'left', width: '90%'}}>
                    <p style={{float: 'left', fontSize: 18}}><b>Regular maintenance of flower beds</b></p>
                  </div>
                </div>
              </div>
            </div>
            <hr className='divider-hr'/>
            <h6 className='text-center brand-primary-color'><b>Select your service plan:</b></h6>
            <div className='row' style={{width: '80%', margin: 'auto'}}>
              <div className='col-xs-6 text-center'>
                <CustomButton classList='pull-right' packageType={this.state.packageType} imageRoot='one-star-gray'
                              handler={(i) => this.toggleButton(i)} index={0} ref='btn0'/>
              </div>
              <div className='col-xs-6 text-center'>
                <CustomButton classList='pull-left' packageType={this.state.packageType} imageRoot='3stars-gray'
                              handler={(i) => this.toggleButton(i)} index={1} ref='btn1'/>
              </div>
              <ServicePlan packageType={this.state.packageType} fullComponent={false}/>
            </div>
            <div className='text-center lead text-nowrap' style={{padding: '0 20px', fontSize: 45}}>
              <b>${this.state.cost}</b><span style={{fontSize: 25}}>/service</span></div>
            <div className='text-center small'
                 style={{margin: '-15px 0 0 0', color: '#78a22f', fontSize: 25}}>{this.state.taskDescription}</div>
            <div className='col-sm-12'>
            </div>
            <div className='text-center pull-down-xs-3' style={{marginBottom: 30}}>
              <button className='btn btn-success' onClick={this.sendUpdateToServer}>Update Task</button>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/modals/upgrade-service-modal.jsx